import React, { Component } from 'react';

import { Button, Table, Popconfirm, Modal } from 'antd';

import format from '@common/utils/formatters/_';

import Create from '@accreditamento/forms/completeRequest/efficacia/CorsiFinanziati';

import EfficaciaServices from '@accreditamento/services/Efficacia';




const columns = (component) => {
  return [
      {
        title: 'Anno',
        dataIndex: 'anno',
        key: 'anno',
        render: (text, record) => (<div style={{width: 150}}>{record.anno}</div>)
      }, {
        title: 'Macrotipologia',
        dataIndex: 'id_tipo_accreditamento',
        key: 'id_tipo_accreditamento',
        render: (text, record) => (<div style={{width: 150}}>{format.replaceStub(record.id_tipo_accreditamento, 'tipo_accreditamento', component.props.GlobalStore)}</div>)
      },
      {
        title: 'Ore autorizzate',
        dataIndex: 'ore_autorizzate',
        key: 'ore_autorizzate',
        render: (text, record) => (<div style={{width: 150}}>{record.ore_autorizzate}</div>)
      },
      {
        title: 'Ore rendicontate',
        dataIndex: 'ore_rendicontate',
        key: 'ore_rendicontate',
        render: (text, record) => (<div style={{width: 150}}>{record.ore_rendicontate}</div>)
      },
      {
        title: '%',
        dataIndex: 'calc',
        key: 'calc',
        render: (text, record) => (<div style={{width: 150}}>{(record.ore_autorizzate !== 0) ? parseInt(record.ore_rendicontate/record.ore_autorizzate * 100) : 0}</div>)
      },
      {
        title: 'Azioni',
        dataIndex: 'azione',
        key: 'azione',
        render: (text, record) => (
          <div style={{width: 120}}>
            {// non dobbiamo mostrare l'ultima
              record.id_tipo_accreditamento ?
            <Popconfirm disabled={component.props.readOnly} placement="leftTop" title="Sicuro di voler rimuovere questo elemento?"
            onConfirm={() => component.delete(record.id)} okText="Si" cancelText="No">
              <Button loading={component.state.deleting.indexOf(record.id) !== -1} className="m2w" size="small" shape="circle" icon="delete" />
            </Popconfirm>
            : null}
          </div>
        ),
      }
    ];
  }


class CorsiFinanziatiList extends Component {

  state = {
    loading: false,
    open_drawer: false,
    updating_model: {},
    deleting: [],
    uploading: [],
    deleting_child: [],
    removing_file: [],
    open_modal: false
  };



  componentDidMount() {
    this.setState({

    })
  }





  delete(id) {
    if(this.state.deleting.indexOf(id) === -1) {
      this.setState({deleting: [...this.state.deleting, id]}, ()=>{
         EfficaciaServices.deleteCorsiFinanziati( this.props.accreditamento.id, id, () => {
           this.setState({deleting: this.state.deleting.filter(e=>e !== id)});
           if(this.props.onDelete) this.props.onDelete(id);
         }, ()=>this.setState({deleting: this.state.deleting.filter(e=>e !== id)}))
      })

    }
  }

  getDataSource() {
    let datas = [...this.props.corsi_finanziati];
    let last_col = {
      id_tipo_accreditamento: null,
      ore_autorizzate: 0,
      ore_rendicontate: 0
    }
    this.props.corsi_finanziati.forEach( c => {
      last_col.ore_autorizzate += c.ore_autorizzate;
      last_col.ore_rendicontate += c.ore_rendicontate
    });

    datas.push(last_col);
    return datas;
  }

  render() {
    return (
      <div style={{marginTop: 32}}>
        <h4>CORSI FINANZIATI DALLA REGIONE CAMPANIA NEGLI ULTIMI TRE ANNI</h4>
        <Button
          type="primary"
          icon="plus"
          className="bg-green"
          disabled={this.props.readOnly}
          onClick={()=>this.setState({open_modal: true})}>
          Aggiungi corso
        </Button>
        <Modal
          title="Inserisci corso"
          visible={this.state.open_modal}
          onCancel={() => {
            this.setState({ open_modal: false }); this.formRef.reset();
          }}
          width={window.innerWidth / 100 * 80}
          okButtonProps={{style: {display: 'none'}}}

        >
          <Create
            ref={inst => (this.formRef = inst)}
            accreditamento={this.props.accreditamento}
            GlobalStore={this.props.GlobalStore}
            tipo_accreditamento={this.props.tipo_accreditamento}
            onCreate={()=>{
              this.setState({open_modal: false})
              this.props.onCreate()
            }}
          />
        </Modal>

        <Table
        loading={this.props.loading_data || this.props.loading_corsi_finanziati}
        columns={columns(this)}
        rowKey={(record)=>"corso_"+record.id}
        pagination={false}
        dataSource={this.getDataSource()} />
      </div>
    );
  }
}
export default CorsiFinanziatiList;